const LoadingComponent = () => (
  <div className="flex items-center justify-center min-h-[400px]">
    <div className="loader h-7 w-7 border-[3px] border-t-transparent border-gray-400 rounded-full animate-spin"></div>
  </div>
);

export default LoadingComponent;
